module.exports = __webpack_public_path__ + "img/builder-12.53624186.jpg";